import { isValid, parse } from 'psl';

interface IDomainValidationOptions {
  allowRoot?: boolean;
  subdomain?: boolean;
  nestedSubdomain?: boolean;
  /**
   * An optional custom message to return when the value is found within the array.
   * If not provided, a default message will be used.
   */
  message?: string;
}

export default function validateDomain(
  value: string,
  {
    allowRoot = false,
    subdomain = false,
    nestedSubdomain = false,
    message,
  }: IDomainValidationOptions = {},
): string[] | null {
  // Let the presence validator handle blank values
  if (!value) {
    return null;
  }

  const invalidDomainError = ['^Domain must be valid.'];
  const invalidRootError = ['^Root domain must be valid.'];
  const invalidSubdomainError = ['^Subdomain must be valid.'];
  const invalidNestedError = ['^Nested subdomain must be valid.'];

  if (!isValid(value)) {
    return invalidDomainError;
  }

  const parsedValue = parse(value);
  const subdomainLevels = parsedValue.subdomain ? parsedValue.subdomain.split('.').length : 0;

  // If no options are set, allow everything valid
  if (!allowRoot && !subdomain && !nestedSubdomain) {
    return null;
  }

  // Check each allowed type
  if (allowRoot && subdomainLevels === 0) {
    return null;
  }
  if (subdomain && subdomainLevels === 1) {
    return null;
  }
  if (nestedSubdomain && subdomainLevels > 1) {
    return null;
  }

  // Return specific error for the configured type
  if (allowRoot && subdomainLevels !== 0) {
    return message ? [message] : invalidRootError;
  }
  if (subdomain && subdomainLevels !== 1) {
    return message ? [message] : invalidSubdomainError;
  }
  if (nestedSubdomain && subdomainLevels <= 1) {
    return message ? [message] : invalidNestedError;
  }

  return invalidDomainError;
}
